import { ORBY_CREATE_INSTANCE, ORBY_GET_INSTANCE_URLS, ORBY_GET_GAS_SPENT_FOR_CUSTOMER, ORBY_GET_GAS_SPENT_FOR_INSTANCES, } from "@orb-labs/types";
import { extractGasSpendForInstances, extractGasSponsorshipData } from "../utils/action_helpers.js";
import { LibraryRequest } from "../actions/library_request.js";
export class AdminActions extends LibraryRequest {
    constructor(library, client, provider) {
        super(library, client, provider);
    }
    async createInstance(name) {
        const result = await this.sendRequest(ORBY_CREATE_INSTANCE, [{ name }]);
        if (result.code && result.message) {
            console.error("[createInstance]", result.code, result.message);
            return undefined;
        }
        return {
            success: result.success ?? false,
            orbyInstancePrivateUrl: result.orbyInstancePrivateUrl ?? "",
            orbyInstancePublicUrl: result.orbyInstancePublicUrl ?? "",
        };
    }
    async getInstanceUrls(name) {
        const result = await this.sendRequest(ORBY_GET_INSTANCE_URLS, [{ name }]);
        if (result.code && result.message) {
            console.error("[getInstanceUrls]", result.code, result.message);
            return undefined;
        }
        return {
            orbyInstancePrivateUrl: result.orbyInstancePrivateUrl ?? "",
            orbyInstancePublicUrl: result.orbyInstancePublicUrl ?? "",
        };
    }
    async getGasSpentForCustomer(month, year) {
        const { totalGasSpentForCustomer, code, message } = await this.sendRequest(ORBY_GET_GAS_SPENT_FOR_CUSTOMER, [{ month, year }]);
        if (code && message) {
            console.error("[getGasSpentForCustomer]", code, message);
            return undefined;
        }
        return extractGasSponsorshipData(totalGasSpentForCustomer);
    }
    async getGasSpentForInstances(month, year, instanceNames) {
        const { totalGasSpendForInstances, code, message } = await this.sendRequest(ORBY_GET_GAS_SPENT_FOR_INSTANCES, [{ month, year, instanceNames }]);
        if (code && message) {
            console.error("[getGasSpentForInstances]", code, message);
            return undefined;
        }
        return extractGasSpendForInstances(totalGasSpendForInstances);
    }
}
